// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileAppNav_root__v2_LE","main":"MobileAppNav_main__fgT4F","active":"MobileAppNav_active__v3KhM"};